/**
 * Bookmark section: scroll reveal, story tabs, gift carousel, challenge form dialog.
 * Scoped per #shopify-section-* wrapper (supports theme editor section:load).
 */
(function () {
  'use strict';

  function initBookmarkSection(rootEl) {
    if (!rootEl || rootEl.getAttribute('data-sm-bookmark-init') === '1') return;
    rootEl.setAttribute('data-sm-bookmark-init', '1');

    // Dynamic Shopify Section ID Resolver
    function resolveDynamicIds() {
      var mainSec = document.querySelector('.shopify-section[id$="__main"], .shopify-section[id*="-main"], #shopify-section-main');
      var offerSec = document.querySelector('.shopify-section[id*="general_offer_cards"], #shopify-section-general_offer_cards_K7yj3X');
      var faqSec = document.querySelector('.shopify-section[id*="faq"], #shopify-section-faq_RbQJfx');

      var links = rootEl.querySelectorAll('.sm-nav-links a, .sm-nav-buy-btn');
      links.forEach(function (link) {
        var href = link.getAttribute('href');
        if (href === '#shopify-section-main' && mainSec) {
          link.setAttribute('href', '#' + mainSec.id);
        } else if (href.indexOf('general_offer_cards') !== -1 && offerSec) {
          link.setAttribute('href', '#' + offerSec.id);
        } else if (href.indexOf('faq') !== -1 && faqSec) {
          link.setAttribute('href', '#' + faqSec.id);
        }
      });
    }
    resolveDynamicIds();

    // Sticky Scroll navigation class toggler
    var navWrapper = rootEl.querySelector('.sm-nav-wrapper');
    var navEl = rootEl.querySelector('.sm-nav');
    if (navWrapper && navEl) {
      var updateSticky = function () {
        var stickyHeader = document.querySelector('.shopify-section--header.shopify-section--sticky, .section-header.shopify-section--sticky, [data-sticky], .header-wrapper--sticky');
        var headerHeight = 0;
        if (stickyHeader) {
          headerHeight = stickyHeader.offsetHeight || 0;
        }
        var themeHeaderHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10);
        if (!isNaN(themeHeaderHeight)) {
          var enableStickyHeader = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--enable-sticky-header') || '1', 10);
          if (enableStickyHeader !== 0) {
            headerHeight = themeHeaderHeight;
          }
        }
        
        var rootRect = rootEl.getBoundingClientRect();
        var heroEl = rootEl.querySelector('.sm-hero');
        var threshold = 300;
        if (heroEl) {
          threshold = Math.max(200, Math.min(450, heroEl.offsetHeight * 0.4));
        }
        
        var shouldShow = rootRect.top < headerHeight - threshold;
        if (shouldShow) {
          navEl.classList.add('is-fixed');
        } else {
          navEl.classList.remove('is-fixed');
        }
      };
      
      window.addEventListener('scroll', updateSticky, { passive: true });
      window.addEventListener('resize', updateSticky, { passive: true });
      updateSticky();
    }

    // Scroll spy using IntersectionObserver
    if ('IntersectionObserver' in window) {
      var spyObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var id = entry.target.id;
            var activeLink = rootEl.querySelector('.sm-nav-links a[href="#' + id + '"]');
            if (activeLink) {
              rootEl.querySelectorAll('.sm-nav-links a').forEach(function (a) {
                a.classList.remove('is-active');
              });
              activeLink.classList.add('is-active');
              
              // Center scroll link on mobile viewports
              var linkContainer = rootEl.querySelector('.sm-nav-links');
              if (linkContainer && linkContainer.scrollWidth > linkContainer.clientWidth) {
                var leftPos = activeLink.offsetLeft - (linkContainer.clientWidth / 2) + (activeLink.offsetWidth / 2);
                linkContainer.scrollTo({ left: leftPos, behavior: 'smooth' });
              }
            }
          }
        });
      }, {
        rootMargin: '-20% 0px -60% 0px',
        threshold: 0
      });

      rootEl.querySelectorAll('.sm-nav-links a').forEach(function (link) {
        var targetId = link.getAttribute('href');
        if (targetId && targetId.indexOf('#') === 0) {
          var targetEl = document.querySelector(targetId);
          if (targetEl) {
            spyObserver.observe(targetEl);
          }
        }
      });
    }

    var reduceMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            /* Section-level elements: toggle is-in-view (keeps observing) */
            if (e.target.hasAttribute('data-sm-section')) {
              if (e.isIntersecting) e.target.classList.add('is-in-view');
              else e.target.classList.remove('is-in-view');
              return;
            }
            /* Reveal elements: one-shot fade in */
            if (!e.isIntersecting) return;
            e.target.style.willChange = 'opacity, transform';
            e.target.classList.add('is-visible');
            e.target.addEventListener(
              'transitionend',
              function () {
                e.target.style.willChange = 'auto';
              },
              { once: true }
            );
            observer.unobserve(e.target);
          });
        },
        { threshold: 0.06, rootMargin: '60px 0px 0px 0px' }
      );
      rootEl.querySelectorAll('.sm-reveal').forEach(function (el) {
        observer.observe(el);
      });
      ['.sm-craft-details', '.sm-designer', '.sm-challenge'].forEach(function (selector) {
        var el = rootEl.querySelector(selector);
        if (el) {
          el.setAttribute('data-sm-section', '1');
          observer.observe(el);
        }
      });
    } else {
      rootEl.querySelectorAll('.sm-reveal').forEach(function (el) {
        el.classList.add('is-visible');
        el.style.willChange = 'auto';
      });
    }

    var wrap = rootEl.querySelector('.sm-stories');
    if (wrap) {
      var track = wrap.querySelector('.sm-carousel-track');
      var tabs = wrap.querySelectorAll('.sm-tab');
      var panels = wrap.querySelectorAll('.sm-carousel-slide');
      var total = tabs.length;
      var current = 0;
      var host = rootEl.querySelector('[data-stories-autoplay]');
      var autoplay = host && host.getAttribute('data-stories-autoplay') === 'true';
      var intervalMs = parseInt(host && host.getAttribute('data-stories-interval'), 10) || 6000;
      var timer = null;

      function revealPanelContent(panel) {
        if (!panel) return;
        panel.querySelectorAll('.sm-reveal').forEach(function (el) {
          el.classList.add('is-visible');
        });
      }

      function goTo(i) {
        if (total === 0) return;
        current = (i + total) % total;
        if (track) track.style.transform = 'none';
        tabs.forEach(function (t, j) {
          var on = j === current;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
        });
        panels.forEach(function (p, j) {
          if (j === current) {
            p.classList.add('is-active');
            p.removeAttribute('hidden');
            p.setAttribute('aria-hidden', 'false');
            revealPanelContent(p);
          } else {
            p.classList.remove('is-active');
            p.setAttribute('hidden', 'hidden');
            p.setAttribute('aria-hidden', 'true');
          }
        });
      }

      tabs.forEach(function (tab, idx) {
        tab.addEventListener('click', function () {
          goTo(idx);
          resetTimer();
        });
      });

      wrap.querySelectorAll('.sm-story-nav').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = parseInt(btn.getAttribute('data-story-dir'), 10) || 1;
          goTo(current + dir);
          resetTimer();
          if (tabs[current]) {
            try {
              tabs[current].focus({ preventScroll: true });
            } catch (err) {
              tabs[current].focus();
            }
          }
        });
      });

      var tablist = wrap.querySelector('.sm-tabs');
      if (tablist) {
        tablist.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
            e.preventDefault();
            goTo(current + 1);
            resetTimer();
            if (tabs[current]) tabs[current].focus();
          } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
            e.preventDefault();
            goTo(current - 1);
            resetTimer();
            if (tabs[current]) tabs[current].focus();
          } else if (e.key === 'Home') {
            e.preventDefault();
            goTo(0);
            resetTimer();
            if (tabs[0]) tabs[0].focus();
          } else if (e.key === 'End') {
            e.preventDefault();
            goTo(total - 1);
            resetTimer();
            if (tabs[total - 1]) tabs[total - 1].focus();
          }
        });
      }

      function resetTimer() {
        if (timer) clearInterval(timer);
        if (!autoplay || reduceMotion || total < 2) return;
        timer = setInterval(function () {
          goTo(current + 1);
        }, intervalMs);
      }

      if (!rootEl.__smVisibilityBound) {
        rootEl.__smVisibilityBound = true;
        document.addEventListener('visibilitychange', function () {
          if (document.hidden) {
            if (timer) clearInterval(timer);
          } else {
            resetTimer();
          }
        });
      }

      wrap.addEventListener('mouseenter', function () {
        if (timer) clearInterval(timer);
      });
      wrap.addEventListener('mouseleave', function () {
        resetTimer();
      });

      goTo(0);
      resetTimer();
    }

    var giftCarousel = rootEl.querySelector('.sm-gift-scroll');
    if (giftCarousel) {
      var giftDots = rootEl.querySelectorAll('.sm-gift-dot');
      function updateGiftDots() {
        if (!giftDots.length) return;
        var cards = giftCarousel.querySelectorAll('.sm-gift-card');
        if (!cards.length) return;
        var active = 0;
        var viewportCenter = giftCarousel.scrollLeft + giftCarousel.clientWidth / 2;
        var minDelta = Infinity;
        cards.forEach(function (card, idx) {
          var center = card.offsetLeft + card.offsetWidth / 2;
          var delta = Math.abs(center - viewportCenter);
          if (delta < minDelta) {
            minDelta = delta;
            active = idx;
          }
        });
        giftDots.forEach(function (dot, idx) {
          if (idx === active) dot.classList.add('is-active');
          else dot.classList.remove('is-active');
        });
      }

      rootEl.querySelectorAll('.sm-gift-nav').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = parseInt(btn.getAttribute('data-gift-dir'), 10) || 1;
          var w = giftCarousel.clientWidth * 0.85;
          giftCarousel.scrollBy({ left: dir * w, behavior: reduceMotion ? 'auto' : 'smooth' });
          window.setTimeout(updateGiftDots, reduceMotion ? 0 : 220);
        });
      });
      giftCarousel.addEventListener('scroll', updateGiftDots, { passive: true });
      window.addEventListener('resize', updateGiftDots);
      updateGiftDots();
    }

    var challengeDialog = rootEl.querySelector('.sm-challenge-form-dialog');
    if (challengeDialog && typeof challengeDialog.showModal === 'function') {
      var openFormBtn = rootEl.querySelector('[data-sm-open-challenge-form]');
      var challengeShell = challengeDialog.querySelector('.sm-challenge-form-dialog__shell');

      function closeChallengeForm() {
        if (challengeDialog.open) challengeDialog.close();
      }

      challengeDialog.addEventListener('close', function () {
        if (openFormBtn && openFormBtn.focus) {
          try {
            openFormBtn.focus({ preventScroll: true });
          } catch (err2) {
            openFormBtn.focus();
          }
        }
      });

      if (openFormBtn) {
        openFormBtn.addEventListener('click', function () {
          if (!challengeDialog.open) challengeDialog.showModal();
          window.setTimeout(function () {
            var focusEl = challengeDialog.querySelector(
              'input:not([type="hidden"]):not([disabled]), textarea:not([disabled]), select:not([disabled])'
            );
            if (focusEl && focusEl.focus) {
              try {
                focusEl.focus({ preventScroll: true });
              } catch (err) {
                focusEl.focus();
              }
            }
          }, 0);
        });
      }

      challengeDialog.querySelectorAll('[data-sm-close-challenge-form]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          closeChallengeForm();
        });
      });

      challengeDialog.addEventListener('mousedown', function (e) {
        if (!challengeShell) return;
        if (!challengeShell.contains(e.target)) closeChallengeForm();
      });
    }
  }

  function boot() {
    document.querySelectorAll('[id^="shopify-section-"]').forEach(function (sec) {
      if (sec.querySelector && sec.querySelector('.sm-animal-dreamers')) {
        initBookmarkSection(sec);
      }
    });
  }

  function scheduleBoot() {
    if (window.__SM_BOOKMARK_DOM__) return;
    window.__SM_BOOKMARK_DOM__ = true;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  }

  if (!window.__SM_BOOKMARK__) {
    window.__SM_BOOKMARK__ = true;
    scheduleBoot();
    document.addEventListener('shopify:section:load', function (ev) {
      var sec =
        ev.target && ev.target.nodeType === 1 && ev.target.classList.contains('shopify-section')
          ? ev.target
          : ev.target && ev.target.closest
            ? ev.target.closest('.shopify-section')
            : null;
      if (sec && sec.querySelector('.sm-animal-dreamers')) {
        sec.removeAttribute('data-sm-bookmark-init');
        initBookmarkSection(sec);
      }
    });
  } else {
    boot();
  }
})();
